<div
  class="sidebar-area bg-white box-shadow"
  [ngClass]="{ active: isToggled }"
  [class.dark-sidebar]="themeService.isSidebarDark()"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
>
  <div class="logo bg-white">
    <a routerLink="/" class="d-flex align-items-center">
      <img [src]="environment.logoUrl" alt="logo" width="40" />
      <span>{{ environment.companyName }}</span>
    </a>
  </div>
  <div class="burger-menu" (click)="toggle()" [ngClass]="{ active: isToggled }">
    <span class="top-bar"></span>
    <span class="middle-bar"></span>
    <span class="bottom-bar"></span>
  </div>
  <ng-scrollbar visibility="hover" style="height: 100vh">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <mat-accordion>
          <span class="sub-title gray-color" *ngIf="isAdminOrSuperAdmin()"
            >CADASTROS</span
          >

          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-menu-1"></i>
                <span class="title">Usuários</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/users/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/users"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Listar todos
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-list"></i>
                <span class="title">Especialidades</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/specialties/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/specialties"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Listar todos
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-list-1"></i>
                <span class="title">Áreas</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/areas/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/areas"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Listar todos
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-user-1"></i>
                <span class="title">Profissionais</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <p
                  class="sidemenu-link"
                  (click)="getClipboardRegisterProfessional()"
                >
                  <span class="title">Link de Cadastro</span>
                </p>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals/register"
                  class="sidemenu-link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span class="title">Cadastrar</span>
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Todos
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals"
                  routerLinkActive="active"
                  [queryParams]="{ status: 'APPROVED' }"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Aprovados
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals"
                  routerLinkActive="active"
                  [queryParams]="{ status: 'REJECTED' }"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Rejeitados
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals"
                  routerLinkActive="active"
                  [queryParams]="{ status: 'PENDING' }"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Em análise
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals/inactive"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Inativos
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professionals/contracts"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Termo de Subscrição - Contrato
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/professional-report-builder"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Construtor de Relatório
                </a>
              </li>
            </ul>
          </mat-expansion-panel>

          <span class="sub-title gray-color" *ngIf="isAdminOrSuperAdmin()"
            >MÓDULOS</span
          >

          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-pulse"></i>
                <span class="title">Hospital</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="hospitals/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="hospitals"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Visualizar
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-house"></i>
                <span class="title">Departamentos</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="departments/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="departments"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Visualizar
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-timers"></i>
                <span class="title">Horários</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="time-slots/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="time-slots"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Visualizar
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-contract"></i>
                <span class="title">Contrato</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="contracts/register"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Cadastrar
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="contracts"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Visualizar
                </a>
              </li>
            </ul>
          </mat-expansion-panel>

          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-calendar"></i>
                <span class="title">Escala</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <!-- <li class="sidemenu-item">
                <a
                  routerLink="/scales/import"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Importar dados
                </a>
              </li> -->
              <li class="sidemenu-item">
                <a
                  routerLink="/shifts/generate"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                  *ngIf="
                    getRole() === 'ADMIN' ||
                    getRole() === 'SUPERADMIN' ||
                    getRole() === 'MANAGER'
                  "
                >
                  Criar/Gerar Plantão
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/shifts/distribute"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Distribuir Plantão
                </a>
              </li>

              <li
                class="sidemenu-item"
                *ngIf="
                  getRole() === 'ADMIN' ||
                  getRole() === 'SUPERADMIN' ||
                  getRole() === 'MANAGER'
                "
              >
                <a
                  routerLink="/shifts"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Calendário
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <!-- <a
            routerLink="/tables/data"
            class="sidebar-menu-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i class="flaticon-resume"></i>
            <span class="title">Notas fiscais</span>
          </a> -->
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-growth"></i>
                <span class="title">Financeiro</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <!-- <li class="sidemenu-item">
                <a
                  routerLink="/finance/dashboard"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Dashboard
                </a>
              </li> -->
              <!-- <li class="sidemenu-item">
                <a
                  routerLink="/finance/expenses"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Despesas
                </a>
              </li> -->
              <!-- <li class="sidemenu-item">
                <a
                  routerLink="/finance/discounts"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Descontos
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/finance/benefits"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Proventos
                </a>
              </li> -->
              <li class="sidemenu-item">
                <a
                  routerLink="/finance/payroll"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Contagem de Plantão
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-envelope"></i>
                <span class="title">Email</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="email"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Entrada
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-chat"></i>
                <span class="title">Chat</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/chat"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Conversas
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
          
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = true"
            *ngIf="isAdminOrSuperAdmin()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i class="flaticon-settings"></i>
                <span class="title">Configurações</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidebar-sub-menu">
              <li class="sidemenu-item">
                <a
                  routerLink="/settings/general"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Geral
                </a>
              </li>
              <li class="sidemenu-item">
                <a
                  routerLink="/settings/integrations"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="sidemenu-link"
                >
                  Integrações
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>
